__turbopack_context__.v({
  "bigImage": "styles-module-scss-module__6MMVkW__bigImage",
  "container": "styles-module-scss-module__6MMVkW__container",
  "desc": "styles-module-scss-module__6MMVkW__desc",
  "desg": "styles-module-scss-module__6MMVkW__desg",
  "img": "styles-module-scss-module__6MMVkW__img",
  "name": "styles-module-scss-module__6MMVkW__name",
  "nameContainer": "styles-module-scss-module__6MMVkW__nameContainer",
  "play": "styles-module-scss-module__6MMVkW__play",
  "root": "styles-module-scss-module__6MMVkW__root",
  "star": "styles-module-scss-module__6MMVkW__star",
  "textContainer": "styles-module-scss-module__6MMVkW__textContainer",
});
